import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RestTranslatorModule } from '../core/translator/rest-translator.module';
import { SFormModule } from '../shared/form/form.module';
import { SharedModule } from '../shared/shared.module';
import { AccessComponent } from './access/access.component';
import { EditProfileRoutingModule } from './editProfile-routing.module';
import { PersonalDataComponent } from './personalData/personalData.component';
import { PersonManagementComponent } from './personManagement/person-management.component';

@NgModule({
  imports: [
    SFormModule,
    CommonModule,
    SharedModule,
    EditProfileRoutingModule,
    RestTranslatorModule
  ],
  declarations: [
    AccessComponent,
    PersonalDataComponent,
    PersonManagementComponent
  ],
  exports: [ AccessComponent ]
})

export class EditProfileModule {
}
